import React from 'react'
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import SchoolIcon from '@mui/icons-material/School';
import HouseIcon from '@mui/icons-material/House';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import FavoriteIcon from '@mui/icons-material/Favorite';

function Overview() {
  return (
    <div className='flex flex-col'>
      <div className='flex mb-5'>
        <p>
          <span className='text-3xl'>I </span>
          am Md. Nazirul Mobin Ahamed. I am a graduate from the Department of Computer Science and Engineering (CSE) at the University of Information Technology and Sciences (UITS). Now I am doing my MBA from Jagannath University, Dhaka. <br /><br />
          As a graduate, I am eager to begin my career in a reputed organization. In the past few years, I built some software projects. I have learned some programming languages (specially C++), OOP concepts and DSA. I did problem solving in different online sites. I also participated in a number of online and offline programming contests. I built some web applications using various technologies and frameworks such as HTML5, CSS3, JavaScript, MERN etc. Recently I have completed some SQA testing projects including manual testing (contains test planning, test case design, bug report and test summary report), automation testing (using Java, Selenium, TestNG and Extent Report) and API testing using Postman.
        </p>
      </div>
      <div className='flex mb-3'>
        <BusinessCenterIcon sx={{ color: 'gray' }} />
        <p className='ml-2'>Works at <span className='font-semibold'>Beginner Learning Academy</span></p>
      </div>
      <div className='flex mb-3'>
        <SchoolIcon sx={{ color: 'gray' }} />
        <p className='ml-2'>Studies MBA in Management Studies at <span className='font-semibold'>Jagannath University</span></p>
      </div>
      <div className='flex mb-3'>
        <SchoolIcon sx={{ color: 'gray' }} />
        <p className='ml-2'>Studied B.Sc. in CSE at <span className='font-semibold'>University of Information Technology and Sciences (UITS)</span></p>
      </div>
      <div className='flex mb-3'>
        <HouseIcon sx={{ color: 'gray' }} />
        <p className='ml-2'>Lives in <span className='font-semibold'>Dhaka, Bangladesh</span></p>
      </div>
      <div className='flex mb-3'>
        <LocationOnIcon sx={{ color: 'gray' }} />
        <p className='ml-2'>From <span className='font-semibold'>Dhaka, Bangladesh</span></p>
      </div>
      <div className='flex'>
        <FavoriteIcon sx={{ color: 'gray' }} />
        <p className='ml-2'>Status Single</p>
      </div>
    </div>
  )
}

export default Overview
